import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2'
import numeral from 'numeral'


const options = {
    legend: {
        display: false,
    },
    elements: {
        point: {
            radius: 0,
        },
    },
    maintainAspectRatio: false,
    tooltips: {
        mode: "index",
        intersect: false,
        callbacks: {
            label: function (tooltipItem, date) {
                return numeral(tooltipItem.value).format("+0.0")
            },
        },
    },
    scales: {
        xAxes: [
            {
                type: "time",
                time: {
                    format: "MM/DD/YY",
                    tooltipItem: 'll'
                },
            },
        ],
        yAxes: [
            {
                gridLines: {
                    display: false,
                },
                ticks: {
                    callback: function (value, index, values) {
                        return numeral(value).format("0a")
                    }
                }
            }
        ]
    }
}

const buildChartData = (data, casesType = 'cases') => {
    const chartData = []
    let lastDataPoint;

    for (let date in data.cases) {
        if (lastDataPoint) {
            const newDataPoint = {
                x: date,
                y: data[casesType][date] - lastDataPoint
            }
            chartData.push(newDataPoint)
        }
        lastDataPoint = data[casesType][date]

    }
    return chartData
}

function LineGraph({ casesType = 'cases', ...props }) {
    const [data, setData] = useState({})

    useEffect(() => {
        const fetchData = async () => {
            await fetch('https://disease.sh/v3/covid-19/historical/all/?lastdays=120')
                .then(response => response.json())
                .then(data => {
                    const chartData = buildChartData(data, casesType)
                    setData(chartData)
                })
        }

        fetchData()

    }, [casesType]);







    return (
        <div className="">
            {
                data?.length > 0 && (
                    <Line
                        options={options}
                        data={{
                            datasets: [{
                                backgroundColor: "rgba(204,16,52,0)",
                                borderColor: "#CC1034",
                                data: data
                            }]
                        }}
                    />
                )
            }

        </div>
    )
}

export default LineGraph;
